import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { getDocumentTheme } from '@/shared/services/helpers/DOM';
import { isInWebView } from '@/shared/webview/env';

const initialState: IAppState = {
  headerConfig: {
    title: '',
    subtitle: '',
    hasBackArrow: false,
    backArrowTo: null,
    helmetTitle: ''
  },
  isLoading: 0,
  // Не хардкод: иначе antd стартует светлым поверх уже тёмной палитры.
  theme: getDocumentTheme(),
  isInWebView: isInWebView()
};

export type TAppState = typeof initialState;

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setHeaderConfig: (
      state,
      action: PayloadAction<Partial<IAppState['headerConfig']>>
    ) => {
      state.headerConfig = {
        ...initialState.headerConfig,
        ...action.payload
      };
    },
    startLoading: (state) => {
      state.isLoading++;
    },
    stopLoading: (state) => {
      state.isLoading--;
      if (state.isLoading < 0) {
        state.isLoading = 0;
      }
    },
    resetLoading: (state) => {
      state.isLoading = 0;
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
    setIsInWebView: (state, action: PayloadAction<boolean>) => {
      state.isInWebView = action.payload;
    },
    setWebviewProperties: (
      state,
      action: PayloadAction<Record<string, unknown>>
    ) => {
      state.webviewProperties = action.payload;
    }
  }
});

export const {
  setHeaderConfig,
  startLoading,
  stopLoading,
  resetLoading,
  setTheme,
  setIsInWebView,
  setWebviewProperties
} = appSlice.actions;
export default appSlice;

interface IAppState {
  headerConfig: {
    title: string;
    subtitle: string;
    hasBackArrow: boolean;
    backArrowTo: string | -1 | null;
    helmetTitle: string;
  };
  isLoading: number;
  theme: 'light' | 'dark';
  isInWebView: boolean;
  webviewProperties?: Record<string, unknown>;
}
